module.exports = __webpack_public_path__ + "6b8345e78f93634af30e74b8e251997f.svg";